import React from "react";
import { FaExclamationTriangle, FaVoteYea } from "react-icons/fa";

export default function VotesEmptyState({
  variant = "empty",
  title = "Aucun vote",
  description = "Aucun vote disponible pour le moment.",
  actionLabel,
  onAction,
}) {
  const Icon = variant === "error" ? FaExclamationTriangle : FaVoteYea;

  return (
    <div className="flex min-h-[320px] items-center justify-center rounded-[1.75rem] border border-dashed border-slate-300 bg-slate-50 p-6 text-center dark:border-slate-700 dark:bg-slate-950/50">
      <div className="mx-auto max-w-md">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-white text-violet-600 shadow-md dark:bg-slate-900 dark:text-violet-300">
          <Icon className="text-xl" />
        </div>

        <h2 className="mt-4 text-xl font-bold text-slate-950 dark:text-white">
          {title}
        </h2>

        <p className="mt-2 text-sm leading-6 text-slate-500 dark:text-slate-400">
          {description}
        </p>

        {actionLabel && onAction && (
          <button
            type="button"
            onClick={onAction}
            className="mt-5 inline-flex min-h-12 items-center justify-center rounded-2xl bg-slate-950 px-5 text-sm font-bold text-white shadow-lg shadow-slate-300/60 transition hover:-translate-y-0.5 hover:shadow-xl dark:bg-white dark:text-slate-950 dark:shadow-black/20"
          >
            {actionLabel}
          </button>
        )}
      </div>
    </div>
  );
}